<template>
	<div class="chat-container w-100 position-relative bg-white">
		<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.top">
			<b-skeleton-img no-aspect width="100%" height="250px"></b-skeleton-img>
			<div class="mt-3 px-4 w-100">
				<b-skeleton width="70%" height="30px"></b-skeleton>
				<b-skeleton width="40%" height="20px"></b-skeleton>
				<b-skeleton width="60%" height="20px"></b-skeleton>
			</div>
		</div>
		<template v-else>
			<!-- SLIDER -->
			<div class="w-100 position-relative">
				<HomeNavbar @shareClick="shareClick" @callClick="callClick" />
				<flickity ref="flickity" :options="headerScrollSlider" v-if="getMerchant.merchant_images.length > 0">
					<div class="carousel-cell w-100" :id="slider_merchant.id" v-for="(slider_merchant,index) in  getMerchant.merchant_images">
						<div class="w-100" style="height: 250px !important;" @click="goToDetailSlider(slider_merchant)">
							<img :src="slider_merchant.image_url" class="img-fit" :alt="index+1" height="250" @click="showGallery(true)">
						</div>
					</div>
				</flickity>
				<div class="position-absolute" @click="showGallery(true)" v-if="getMerchant.merchant_images.length > 1" style="right: 24px;top: 200px;">
					<img src="../../assets/img/icon/menu-navbar/Image-More.svg" alt="More" width="32">
				</div>
			</div>

			<!-- PROMO -->
			<template v-if="data_parent.promo.length > 0">
				<router-link :to="'/'+getMerchant.code+'/promo'">
					<div class="promo-mobile position-relative px-4 py-3">
						<div class="row no-gutters">
							<div class="col-1">
								<div class="d-inline-block icon">
									<img src="../../assets/img/icon/menu-navbar/Promo.svg" alt="Promo" width="42">
								</div>
							</div>
							<div class="col-10">
								<div class="d-inline-block text">
									<p class="mb-0 body-1-2 text-15 font-semibold position-relative z-index-1038">{{$t('hotel.concierge.fitur.there-are')}} {{data_parent.promo.length}} {{$t('hotel.concierge.fitur.interesting-promos')}}</p>
									<p class="mb-0 body-1-2 text-12 font-regular">{{$t('hotel.concierge.fitur.click-to-get-attractive-promos')}}</p>
								</div>
							</div>
							<div class="col-1 text-right">
								<img src="../../assets/img/icon/back-arrow.png" class="mt-2 transform-180" alt="Promo" width="12">
							</div>
							<div class="bg">
								<img src="../../assets/img/icon/menu-navbar/Promo-Bg.svg" alt="Promo" class="w-100">
							</div>
						</div>
					</div>
				</router-link>
			</template>

			<!-- TITLE -->
			<div class="p-4 border-b-semi-grey mb-4">
				<p class="mb-3 font-bold body-2-2 text-22">{{getMerchant.name}}</p>
        <div v-if="getMerchant.star > 0" class="d-flex align-items-center mb-2">
          <svg class="flex-0" width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="18" height="18" rx="2" fill="#F7941D"></rect>
            <path d="M12.452 10.353C12.3009 10.4994 12.2315 10.7112 12.2659 10.9188L12.7845 13.7888C12.8283 14.0321 12.7256 14.2783 12.522 14.4188C12.3225 14.5647 12.0571 14.5822 11.8395 14.4655L9.25594 13.118C9.16611 13.0702 9.06636 13.0445 8.96428 13.0416H8.80619C8.75136 13.0498 8.69769 13.0673 8.64869 13.0941L6.06453 14.448C5.93678 14.5122 5.79211 14.5349 5.65036 14.5122C5.30503 14.4468 5.07461 14.1178 5.13119 13.7708L5.65036 10.9008C5.68478 10.6913 5.61536 10.4784 5.46428 10.3297L3.35786 8.28801C3.18169 8.11709 3.12044 7.86042 3.20094 7.62884C3.27911 7.39784 3.47861 7.22926 3.71953 7.19134L6.61869 6.77076C6.83919 6.74801 7.03286 6.61384 7.13203 6.41551L8.40953 3.79634C8.43986 3.73801 8.47894 3.68434 8.52619 3.63884L8.57869 3.59801C8.60611 3.56767 8.63761 3.54259 8.67261 3.52217L8.73619 3.49884L8.83536 3.45801H9.08094C9.30028 3.48076 9.49336 3.61201 9.59428 3.80801L10.8887 6.41551C10.982 6.60626 11.1634 6.73867 11.3729 6.77076L14.272 7.19134C14.517 7.22634 14.7218 7.39551 14.8029 7.62884C14.8793 7.86276 14.8134 8.11942 14.6337 8.28801L12.452 10.353Z" fill="white"></path>
          </svg>
          <p class="mb-0 body-3 ml-2">{{ getMerchant.star }} Stars {{ getMerchant.merchant_category_name ? getMerchant.merchant_category_name : "" }}</p>
        </div>
        <div class="d-flex">
          <svg style="margin-top: 2px" class="me-6 flex-0" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M2.91602 8.59846C2.91602 4.76523 6.11925 1.66699 9.99389 1.66699C13.8794 1.66699 17.0827 4.76523 17.0827 8.59846C17.0827 10.5301 16.3802 12.3233 15.2239 13.8433C13.9484 15.5199 12.3761 16.9807 10.6065 18.1273C10.2014 18.3923 9.83591 18.4123 9.39139 18.1273C7.61163 16.9807 6.03942 15.5199 4.77477 13.8433C3.61767 12.3233 2.91602 10.5301 2.91602 8.59846ZM7.66121 8.81428C7.66121 10.0984 8.70906 11.1084 9.99389 11.1084C11.2796 11.1084 12.3375 10.0984 12.3375 8.81428C12.3375 7.54015 11.2796 6.48102 9.99389 6.48102C8.70906 6.48102 7.66121 7.54015 7.66121 8.81428Z"
              fill="#AAAAAA"></path>
          </svg>
          <p class="mb-0 body-3 ml-2 cursor-pointer" @click="isLocation()">
            <u>{{ getMerchant.address }}</u>
          </p>
        </div>
			</div>
		</template>

		<!-- RESERVATION DETAIL -->
		<div class="w-100 pb-4 px-4 mb-4 border-b-semi-grey" v-if="is_load.reservation">
			<b-row class="slim-grid-row">
				<b-col cols="12" class="mb-3">
					<b-skeleton width="20%" height="30px"></b-skeleton>
				</b-col>
				<b-col cols="12">
					<b-card body-class="p-3">
						<b-row no-gutters>
							<b-col cols="4" class="align-self-center">
								<b-row class="slim-grid-row">
									<b-col cols="6">
										<b-skeleton width="100%" height="57px"></b-skeleton>
									</b-col>
									<b-col cols="6">
										<b-skeleton width="100%" height="15px"></b-skeleton>
										<b-skeleton width="80%" height="15px"></b-skeleton>
										<b-skeleton width="60%" height="15px"></b-skeleton>
									</b-col>
								</b-row>
							</b-col>
							<b-col cols="3" offset="5" class="align-self-center">
								<b-skeleton width="100%" height="40px"></b-skeleton>
							</b-col>
							<b-col cols="12" class="my-3">
								<div class="w-100 border-2-bottom-dashed"></div>
							</b-col>
							<b-col cols="4">
								<b-skeleton width="30%" height="15px"></b-skeleton>
								<b-skeleton width="50%" height="20px"></b-skeleton>
							</b-col>
							<b-col cols="4">
								<b-skeleton width="30%" height="15px"></b-skeleton>
								<b-skeleton width="50%" height="20px"></b-skeleton>
							</b-col>
							<b-col cols="4">
								<b-skeleton width="30%" height="15px"></b-skeleton>
								<b-skeleton width="50%" height="20px"></b-skeleton>
							</b-col>
							<b-col cols="12" class="my-3">
								<div class="w-100 border-2-bottom-dashed"></div>
							</b-col>
							<b-col cols="12">
								<b-skeleton width="70%" height="20px"></b-skeleton>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</div>
		<template v-else>
			<div class="w-100 mb-5 px-4" v-if="data_parent.reservation.id">
				<div class="w-100 pb-4 mb-5 border-b-semi-grey">
					<p class="sub-heading-1-1 mb-3 text-semi-dark">Reservation Detail</p>
					<div class="w-100 border-semi-grey radius-8 p-3">
						<div class="row no-gutters">
							<div class="col-12 text-center py-3" v-if="data_parent.reservation_load">
								<loader />
							</div>
							<template v-else>
								<div class="col-2 align-self-center">
									<div class="w-100 pr-2">
										<div class="w-100 bg-orange text-center radius-8" style="padding:13px 0px;">
											<i class="simple-icon-home text-18 text-white"></i>
										</div>
									</div>
								</div>
								<div class="col-7 align-self-center">
									<div class="pr-2">
										<p class="mb-0 body-2-1" :class="{'text-danger': data_parent.reservation.room_type.name == 'Unallocated Room Type'}">{{data_parent.reservation.room_type.name}}</p>
										<div class="w-100 no-ws">
											<p class="mb-0 d-inline-block align-middle body-3-3-1 mr-2">Room : </p>
											<p class="mb-0 d-inline-block align-middle body-3-1" :class="{'text-danger': data_parent.reservation.room.name == 'Unallocated'}">{{data_parent.reservation.room.name}}</p>
										</div>
										<p class="mb-0 body-3-1 text-info">Folio {{data_parent.reservation.folio_number != '' ? `#${data_parent.reservation.folio_number}` : '#'}}</p>
									</div>
								</div>
								<div class="col-3 align-self-center text-right">
									<p class="mb-0 body-3-3-1">Status</p>
									<p class="mb-0 body-3-1" :class="reservation_status.text_color">{{reservation_status.title}}</p>
								</div>
								<div class="col-12 my-3">
									<div class="w-100 border-2-bottom-dashed"></div>
								</div>
								<div class="col-6">
									<p class="mb-0 body-3-3-1">Check in</p>
									<p class="mb-0 body-3-1">{{$formatDate(data_parent.reservation.arrival_date,'YYYY-MM-DD')}}</p>
								</div>
								<div class="col-6">
									<p class="mb-0 body-3-3-1">Check out</p>
									<p class="mb-0 body-3-1">{{$formatDate(data_parent.reservation.departure_date,'YYYY-MM-DD')}}</p>
								</div>
								<div class="col-12 my-3">
									<div class="w-100 border-b-semi-grey"></div>
								</div>
								<div class="col-12 text-center">
									<p class="mb-0 body-3-1">{{reservation_status.description}}</p>
								</div>
								<div class="col-12 mt-2" v-if="data_parent.reservation.status == 'SUBMIT_FORM' || data_parent.reservation.status == 'PRE_CHECKIN' || data_parent.reservation.status == 'CHECKIN' || (getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser)">
									<button type="button" v-if="data_parent.reservation.status == 'SUBMIT_FORM' || data_parent.reservation.status == 'PRE_CHECKIN'" class="g-btn w-100 g-btn-primary g-btn-md" :class="getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser ? 'mb-2' : ''" @click="checkStatus()">Check Status</button>
									<button v-if="getMerchant.reservation_detail_show_bill && isCurrentUserSameWithRsvUser" type="button" class="g-btn w-100 g-btn-secondary-outline g-btn-md" @click="openGuestBill()">Guest Bill</button>
								</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</template>

		<!-- ROOM TYPE -->
		<RoomTypePreviewMobile  v-if="getMerchant.use_booking_engine && getMerchant.is_show_room_type" data_source="parent" :parent_data="data_parent.room_type" :is_load="is_load.room_type"></RoomTypePreviewMobile>


    <div class="px-4">
    	<!-- MENU SERVICE -->
			<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.small_menu">
				<b-row class="slim-grid-row">
					<b-col cols="12" class="mb-3">
						<b-skeleton width="20%" height="40px"></b-skeleton>
						<b-skeleton width="50%" height="20px"></b-skeleton>
					</b-col>
					<b-col cols="12" class="mb-3" v-for="i in 2" :key="i">
						<b-card no-body img-left>
							<b-skeleton-img no-aspect width="35%" height="95px" card-img="left"></b-skeleton-img>
							<b-card-body class="p-2">
								<b-skeleton width="40%" height="20px"></b-skeleton>
								<b-skeleton width="60%" height="15px" class="mb-2"></b-skeleton>
								<b-skeleton width="20%" height="20px" class="d-table ml-auto mb-0"></b-skeleton>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
			</div>
			<template v-else>
				<div class="w-100 pb-4 pt-1 mb-5 border-b-semi-grey" v-if="data_parent.menu.length > 0">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{$t('hotel.concierge.fitur.book-our-services')}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{$t('hotel.concierge.fitur.fitur-desc')}}</p>
					<!-- MENU ITEM -->
					<div
						class=""
						v-for="(menu_service,index) in data_parent.menu"
						:key="index">
						<div class="row border-semi-grey radius-12 mb-3 no-gutters"
							v-if="menu_service.merchant_pos"
							@click="detailModuleClick(menu_service.merchant_pos)">
							<div class="col-4 radius-12" style="height: 95px;" v-if="menu_service.merchant_pos.slider.length > 0">
								<img v-if="menu_service.merchant_pos.slider.length == 1" :src="menu_service.merchant_pos.slider[0].image_url" class="img-fit radius-12-l" :alt="getMerchant.name">
								<flickity v-else ref="flickity" class="mb-3" :options="freeScrollSlider">
									<div class="carousel-cell w-100" style="height: 95px;" v-for="menu_slider in menu_service.merchant_pos.slider">
										<img :src="menu_slider.image_url" class="img-fit radius-12-l" :alt="getMerchant.name">
									</div>
								</flickity>
							</div>
							<div :class="menu_service.merchant_pos.slider.length > 0 ? 'col-8' : 'col-12'">
								<div class="w-100 px-3 py-2">
									<p class="body-1-2 mb-1 position-relative text-truncate" style="top:4px">{{menu_service.merchant_pos.tagline}}</p>
									<p class="body-2-2-1 mb-0 text-truncate" v-if="menu_service.merchant_pos.sub_tagline">{{menu_service.merchant_pos.sub_tagline}}</p>
									<div class="w-100 mt-1">
										<div class="d-table link-green-arrow ml-auto" @click="detailModuleClick(menu_service.merchant_pos)">
											<p class="mb-0 d-inline-block aling-middle text-12">{{$t('hotel.concierge.fitur.read-more')}}</p>
											<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-10" ></i>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>

	    <!-- MENU SERVICE PREVIEW -->
			<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.big_menu">
				<b-row class="slim-grid-row">
					<b-col cols="12" class="mb-3">
						<b-skeleton width="20%" height="40px"></b-skeleton>
						<b-skeleton width="50%" height="20px"></b-skeleton>
					</b-col>
					<b-col cols="12">
						<b-card>
							<b-row class="mb-4">
								<b-col cols="12" class="mb-3">
									<b-skeleton width="20%" height="25px"></b-skeleton>
									<b-skeleton width="50%" height="15px"></b-skeleton>
								</b-col>
								<b-col cols="8">
									<b-skeleton-img no-aspect width="100%" height="185px"></b-skeleton-img>
								</b-col>
								<b-col cols="4">
									<b-skeleton-img no-aspect width="100%" height="185px"></b-skeleton-img>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="12" class="mb-2">
									<b-skeleton width="20%" height="25px"></b-skeleton>
									<b-skeleton width="50%" height="15px"></b-skeleton>
								</b-col>
								<b-col cols="4" v-for="i in 3" :key="i">
									<b-skeleton-img no-aspect width="100%" height="120px"></b-skeleton-img>
									<b-skeleton width="40%" height="20px" class="mt-3"></b-skeleton>
									<b-skeleton width="50%" height="15px"></b-skeleton>
								</b-col>
							</b-row>
						</b-card>
					</b-col>
				</b-row>
			</div>
			<template v-else>
				<div class="w-100 pb-5 border-b-semi-grey mb-5" v-for="(menu_preview,index) in data_parent.preview" v-if="menu_preview.service_type == 'MERCHANT_POS'">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{menu_preview.tagline}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{menu_preview.sub_tagline}}</p>
					<RoomDiningPreview
						v-if="menu_preview.merchant_pos.code=='concierge-room-dining'"
						type="mobile"
						:data="menu_preview" />
					<ThingsToDoPreview
						v-if="menu_preview.merchant_pos.code=='concierge-experience'"
						type="mobile"
						:data="menu_preview.merchant_pos" />
					<SpaPreview
						v-if="menu_preview.merchant_pos.code=='concierge-spa'"
						type="mobile"
						:data="menu_preview.merchant_pos" />
					<LaundryPreview
						v-if="menu_preview.merchant_pos.code=='concierge-laundry'"
						type="mobile"
						:data="menu_preview" />
				</div>

				<div class="w-100 pb-5" v-for="(upselling,index) in data_parent.preview" v-if="upselling.service_type == 'UPSELLING_PRODUCT_GROUP'">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{upselling.tagline}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{upselling.sub_tagline}}</p>
					<VoucherPreview
						type="mobile"
						:data="upselling" />
				</div>
			</template>

			<div class="w-100 pb-4 mb-4 border-b-semi-grey" v-if="is_load.bottom">
				<b-row class="slim-grid-row">
					<b-col cols="12" class="mb-3">
						<b-skeleton width="20%" height="40px"></b-skeleton>
						<b-skeleton width="50%" height="20px"></b-skeleton>
					</b-col>
					<b-col cols="6" v-for="i in 2" :key="i">
						<b-card no-body img-left>
							<b-skeleton-img no-aspect width="35%" height="58px" card-img="left"></b-skeleton-img>
							<b-card-body class="p-2">
								<b-skeleton width="40%" height="20px"></b-skeleton>
								<b-skeleton width="60%" height="15px" class="mb-0"></b-skeleton>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
			</div>
			<template v-else>
				<!-- SOCIAL MEDIA -->
				<div class="w-100 mb-5" v-if="getMerchant.social_media.length > 0">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{getMerchant.merchant_social_media_title}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{getMerchant.merchant_social_media_subtitle}}</p>
					<div class="w-100">
						<div class="w-100 mb-3" v-for="(sosmed,index) in getMerchant.social_media" :key="index">
							<CustomUrl :data="sosmed" type="social_media"></CustomUrl>
						</div>
					</div>
				</div>

				<!-- CUSTOM URL -->
				<div class="w-100 mb-5" v-if="getMerchant.merchant_link.length > 0">
					<p class="sub-heading-1-1 mb-1 text-semi-dark">{{getMerchant.merchant_link_title}}</p>
					<p class="body-2-2-1 mb-3 sub-title">{{getMerchant.merchant_link_subtitle}}</p>
					<div class="w-100">
						<div class="w-100 mb-3" v-for="(custom_url,index) in getMerchant.merchant_link" :key="index">
							<CustomUrl :data="custom_url" type="custom"></CustomUrl>
						</div>
					</div>
				</div>

				<!-- OTHER INFORMATION -->
				<div class="w-100 mb-5" v-if="getMerchant.check_in_time_start != '' && getMerchant.check_out_time_start != ''">
					<p class="mb-3 sub-heading-1-1">{{$t('general.about-accommodation')}}</p>
					<div class="mb-3" v-if="getMerchant.description != ''">
						<!-- <p class="mb-2 body-3-3 text-16 font-bold">{{$t('general.description')}}</p> -->
						<div class="mb-4 body-3-3 text-15 font-medium text-truncate-10 html-desc" v-html="getMerchant.description"></div>
						<p class="mb-0 body-2-1 d-table cursor-pointer text-green border-bottom-green"
							@click="togglePopupInfo($t('general.about-accommodation'),getMerchant.description)">
							Read More
						</p>
					</div>
					<div class="row">
						<div class="col-6">
							<div class="border-semi-grey radius-12 py-2 text-center">
								<p class="mb-0 body-2-2-1">{{$t('hotel.check-in-time')}}</p>
								<p class="mb-0 body-1-2">{{formatTime(getMerchant.check_in_time_start)}}</p>
								<p class="mb-0 body-3-3-1">UTC{{getMerchantTimezone.offset}}</p>
							</div>
						</div>
						<div class="col-6">
							<div class="border-semi-grey radius-12 py-2 text-center">
								<p class="mb-0 body-2-2-1">{{$t('hotel.check-out-time')}}</p>
								<p class="mb-0 body-1-2">{{formatTime(getMerchant.check_out_time_end)}}</p>
								<p class="mb-0 body-3-3-1">UTC{{getMerchantTimezone.offset}}</p>
							</div>
						</div>
					</div>
				</div>


				<div class="w-100 mb-5" v-if="facilities.length > 0">
					<p class="mb-3 sub-heading-1-1">{{$t('general.facilities')}}</p>
					<div class="row slim-grid-row mb-3">
						<div class="col-6 mb-3" v-for="facility in visibleFacilities" :key="facility.id">
							<Facility :data="facility"></Facility>
						</div>
					</div>
					<div class="w-100 radius-12 text-center mt-3 g-btn-lg border-green" @click="toggleFacility" v-if="hasHiddenFacilities">
						<p class="mb-0 d-inline-block aling-middle">{{$t('hotel.concierge.fitur.load-more')}}</p>
						<i class="iconsmind-Arrow-Right font-weight-bold d-inline-block aling-middle text-12" ></i>
					</div>
				</div>

				<div class="w-100 mb-5" id="location">
					<p class="mb-3 sub-heading-1-1">{{$t('general.location')}}</p>
					<p class="mb-2 body-2-2-1"><img src="../../assets/img/hotel/marker.png" class="mr-2" width="15" :alt="getMerchant.name"> {{getMerchant.address}}</p>
					<div class="w-100 pb-4">
            <iframe v-if="$isNotEmptyV2(getMerchant.location_embed_map)" :src="getMerchant.location_embed_map" width="100%" height="200" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            <ShowGmaps v-else />
					</div>
				</div>

				<!-- PARTNER PREVIEW -->
				<div v-if="getMerchant.verified_by.length > 0">
					<PartnerPreview></PartnerPreview>
				</div>
				<div class="mb-5 w-100">
					<div class="border-b-semi-grey py-2 mb-2 cursor-pointer" v-if="getMerchant.terms_and_conditions != ''" @click="togglePopupInfo($t('hotel.concierge.fitur.terms-conditions'),getMerchant.terms_and_conditions)">
						<div class="row slim-grid-row">
							<div class="col-11">
								<p class="mb-0 body-3-3 text-16 font-bold">{{$t('hotel.concierge.fitur.terms-conditions')}}</p>
							</div>
							<div class="col-1">
								<i class="simple-icon-arrow-right mt-2"></i>
							</div>
						</div>
					</div>
					<div class="border-b-semi-grey py-2 my-2 cursor-pointer" v-if="getMerchant.cancellation_policy != ''" @click="togglePopupInfo($t('merchant.cancellation-policy'),getMerchant.cancellation_policy)">
						<div class="row slim-grid-row">
							<div class="col-11">
								<p class="mb-0 body-3-3 text-16 font-bold">{{$t('merchant.cancellation-policy')}}</p>
							</div>
							<div class="col-1">
								<i class="simple-icon-arrow-right mt-2"></i>
							</div>
						</div>
					</div>
				</div>
			</template>
    </div>

    <!-- FLOATING MENU -->
    <transition name="fade">
      <template v-if="!is_load.be && show_booking_engine_section">
        <div class="position-relative" style="z-index: 1027;">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block" style="bottom:0px">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="container bg-white px-4 py-12px" style="box-shadow: 0px -3px 13px 0px #0000000f">
                      <div class="row">
                        <template>
                          <div class="col-6">
                          	<template v-if="getMerchant.use_booking_engine && data_parent.lowest_price>0">
	                            <p class="mb-0 body-2-2 text-12" style="padding-top:2px">{{$t('merchant.starting-from')}}</p>
	                            <p class="mb-0 body-2-2 text-18 text-orange font-bold d-inline-block">{{$formatCurrency(data_parent.lowest_price)}}</p>
	                          </template>
                          </div>
                          <div class="col-6 text-right" @click="$trackHomeClick('','Clicked Find Rooms')">
                          	<button v-if="getMerchant.use_custom_booking_engine_landing_page" type="button" class="g-btn g-btn-primary g-btn-lg" style="padding-top:12px;padding-bottom:12px" @click="goToCustomBookingPage">{{$t('hotel.action.book-now')}}</button>
                            <router-link v-else :to="'/'+getMerchant.code+'/booking'">
															<button type="button" class="g-btn g-btn-primary g-btn-lg" style="padding-top:12px;padding-bottom:12px">{{$t('hotel.action.book-now')}}</button>
														</router-link>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition>



    <!-- DETAIL FACILITY -->
    <BeFacilitiesModal
      :is-open="show_facility"
      :categories="facilityCategories"
      @close="toggleFacility" />

    <!-- DETAIL BASIC INFORMATION -->
    <popup-detail
    	direction="bottom"
    	:show="popup_info.show"
    	:use_max_size="true"
    	:title="popup_info.title"
    	@close="togglePopupInfo">
    	<template v-slot:body>
	    	<div class="py-3 px-4">
	        <div class="html-desc" v-html="popup_info.body">
	        </div>
	    	</div>
	    </template>
    </popup-detail>
    <!-- GALLERY -->
  	<transition name="fade">
 			<template v-if="is_gallery">
	    	<div class="container">
		      <div class="fixed-top d-block nav-bottom bg-white pop-up fit-to-screen scroll-hide-mobile z-index-1042 w-100">
		        <div class="custom-container-fluid px-0">
		          <div class="row justify-content-center no-gutters">
		            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
		              <div class="container px-4 pb-4">
		              	<div class="position-sticky w-100 bg-white top-0 z-index-1036 py-3">
		              		<div class="row">
		              			<div class="col-2" @click="showGallery(false)">
		              				<img src="../../assets/img/icon/back.png" class="cursor-pointer" width="20">
		              			</div>
		              			<div class="col-10 text-right">
		              				<router-link :to="'/'+getMerchant.code+'/gallery'" class="d-inline-block" @click.native="$trackHomeClick('NAVBAR','Clicked menu gallery')">
														<img
									    				src="../../assets/img/icon/menu-navbar/Image.png"
									    				width="20"
									    				:alt="getMerchant.name">
								    				<p class="mb-0 body-1-2 d-inline-block position-relative" style="top:1px">{{$t('restaurant.menu.gallery')}}</p>
													</router-link>
		              			</div>
		              		</div>
		              	</div>
		              	<div class="row slim-grid-row-1">
			              	<div class="col-6 mb-2"
			              		:class="{'col-12': index_image_slider == 0 || index_image_slider == 3 || index_image_slider == 8}"
			              		v-for="(image_slider,index_image_slider) in getMerchant.merchant_images"
			              		:key="index_image_slider"
			              		@click="index = index_image_slider">
			              		<img :src="image_slider.image_url" class="object-fit w-100" :alt="getMerchant.name" height="200">
			              	</div>
			              </div>
		              </div>
		            </div>
		          </div>
		        </div>
		      </div>
		      <CoolLightBox
			      :items="getMerchant.merchant_images"
			      srcName="image_url"
			      :index="index"
			      :closeOnClickOutsideMobile="true"
			      @close="index = null">
			    </CoolLightBox>
		    </div>
  		</template>
	  </transition>
    <div class="height-50px" v-if="getMerchant.use_booking_engine"></div>
    <!-- GUEST BILL -->
    <GuestBill ref="guest_bill"></GuestBill>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
	import {get} from '@/services/index.js';
	import {calculateFinalPriceConcierge} from '@/utils/index.js'
  import Flickity from 'vue-flickity';
  import CustomUrl from '@/components/hotel/general/CustomUrl'
  import Facility from '@/components/hotel/general/Facility'
  import RoomDiningPreview from '@/components/hotel/general/RoomDiningPreview'
  import ThingsToDoPreview from '@/components/hotel/general/ThingsToDoPreview'
  import SpaPreview from '@/components/hotel/general/SpaPreview'
  import LaundryPreview from '@/components/hotel/general/LaundryPreview'
  import VoucherPreview from '@/components/hotel/general/VoucherPreview'
  import GuestBill from '@/components/hotel/general/GuestBill'
  import moment from 'moment';
  import CoolLightBox from 'vue-cool-lightbox'
	import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
	import HomeNavbar from '@/components/hotel/be/mobile/HomeNavbar'
	import RoomTypePreviewMobile from '@/components/hotel/general/RoomTypePreviewMobile'
  import PartnerPreview from '@/components/hotel/general/PartnerPreview'
  import BeFacilitiesModal from '@/components/hotel/be/v3/BeFacilitiesModal.vue'
  import { fetchMerchantFacilityCategories, flattenFacilityCategories } from '@/utils/merchantFacility.js'

  const VISIBLE_FACILITY_LIMIT = 6

	export default{
		props: ['data_parent'],
		components:{
			Flickity,
			CustomUrl,
			Facility,
			RoomDiningPreview,
			ThingsToDoPreview,
			SpaPreview,
			LaundryPreview,
			VoucherPreview,
			CoolLightBox,
			GuestBill,
			HomeNavbar,
			RoomTypePreviewMobile,
			PartnerPreview,
			BeFacilitiesModal
		},
		data(){
			return{
				topSliderOption: {
          initialIndex: 0,
          autoPlay: 3000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: true,
        },
        headerScrollSlider: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: true,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: false,
          contain: false
        },
        freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 5000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: false,
          draggable: true,
          wrapAround: false,
          contain: true
        },
        scrollPosition: 0,
        show_navbar: false,
        show_facility: false,
        facilityCategories: [],
        popup_info:{
        	show: false,
        	title: '',
        	body: ''
        },
        is_gallery: false,
        index: null,
        summary:"",
        reservation_pin: '',
        reservation_pin_error: ''
			}
		},
		computed:{
			...mapGetters(['getMerchant','getBeFilter','getCurrentLanguage','getCurrency','getMerchantTimezone','isLoggedIn','isCurrentUserSameWithRsvUser', 'isReservationActive']),
			reservation_status(){
				if(this.data_parent.reservation.id){
					let return_data = {
						title: '',
						text_color: '',
						description: ''
					}

					if(this.data_parent.reservation.status == 'SUBMIT_FORM'){
						return_data = {
							title: 'Waiting for Approval',
							text_color: 'text-secondary',
							description: 'Your data is waiting for approval by the front office. Please wait until the process done.'
						}
					}else if(this.data_parent.reservation.status == 'PRE_CHECKIN' || this.data_parent.reservation.status == 'CHECKIN'){
						return_data = {
							title: this.data_parent.reservation.status == 'PRE_CHECKIN' ? 'Pre Check In' : 'Check In',
							text_color: this.data_parent.reservation.status == 'PRE_CHECKIN' ? 'text-info' : 'text-success',
							description: 'Make yourself comfortable and enjoy all the services we have provided for you.'
						}
						if(this.isLoggedIn){
							if(!this.isCurrentUserSameWithRsvUser){
								return_data.description = 'This reservation is connected to a guestaps account that is different from your current account. If you want to log in with that account, you can open a message containing the auto login url in your email'
							}
						}else{
							return_data.description = 'Your data has been validated. There are many offers if you log in with a Guestaps account, please check your email for automatic login to your Guestaps account'
						}
					}

					return return_data
				}else{
					return null
				}
			},
			is_load(){
				return this.data_parent.loading_section
			},
			show_booking_engine_section(){
				if(this.isReservationActive || !this.getMerchant.use_booking_engine) return false
				else return true
			},
			facilities(){
				return flattenFacilityCategories(this.facilityCategories)
			},
			hasHiddenFacilities(){
				return this.facilities.length > VISIBLE_FACILITY_LIMIT
			},
			visibleFacilities(){
				return this.facilities.slice(0, VISIBLE_FACILITY_LIMIT)
			}
		},
		watch:{
			concierge_status(){
				if(this.concierge_status == 'pin_not_match'){
					this.reservation_pin_error = 'Incorrect PIN, please try again'
				}else{
					this.reservation_pin_error = ''
				}
			}
		},
		mounted(){
      this.loadMerchantFeedback()
      this.loadFacilityCategories()
		},
		methods:{
			openGuestBill(){
				this.$refs.guest_bill.toggleDetail()
			},
			callClick(){
				this.$emit('callClick')
			},
			detailPromotion(){
      	this.$trackHomeClick("PROMOTION","Clicked promotion")
      },
      goToSearchRoom(){
      	this.$trackHomeClick("PREVIEW BOOK ROOM","Clicked book now")
      	this.$router.push(`/${this.getMerchant.code}/booking`)
      },
			printBestMenuPrice(product){
				let price = product.variant_list.length == 0 ? product.price : product.variant_list[0].price
				return calculateFinalPriceConcierge(price)
			},
			formatTime(time){
        return moment(time, 'HH:mm:ss').format('HH:mm')
      },
      toggleBurgerMenu(){
      	this.show_navbar = !this.show_navbar
      },
      toggleFacility(){
      	this.show_facility = !this.show_facility
      },
      async loadFacilityCategories(){
      	this.facilityCategories = await fetchMerchantFacilityCategories(this.getMerchant)
      },
      togglePopupInfo(title='',body=''){
      	this.popup_info.show = !this.popup_info.show
    		this.popup_info.title = title
    		this.popup_info.body = body
    		this.$trackHomeClick('FOOTER',`Clicked detail ${title}`)
      },
      shareClick(){
        this.$emit("shareClick")
      },
      detailModuleClick(pos){
      	this.$emit('detailModuleClick',pos)
      },
      goToDetailSlider(slider){
      	this.$emit('goToDetailSlider',slider)
      },
      showGallery(data){
      	this.is_gallery = data
      	document.querySelector('body').style.overflow = data ? 'hidden' : 'auto';
      },
      isLocation(){
      	document.getElementById('location').scrollIntoView({
	          behavior: 'smooth'
	      });
      },
      formatCustomDate(data,frmt){
      	return moment(data).format(frmt)
      },
      goToCustomBookingPage(){
      	let cloned_data = this.$deepCopy(this.getBeFilter)
      	let parsed_url = this.getMerchant.custom_booking_engine_landing_page_url
  			let params = [
					{ name: "Checkin Date (DD)", parameter: "{{checkin_date}}", value: this.formatCustomDate(cloned_data.date.check_in,'DD') },
				  { name: "Checkin Month (MM)", parameter: "{{checkin_month}}", value: this.formatCustomDate(cloned_data.date.check_in,'MM') },
				  { name: "Checkin Year (YYYY)", parameter: "{{checkin_year}}", value: this.formatCustomDate(cloned_data.date.check_in,'YYYY') },
				  { name: "Checkout Date (DD)", parameter: "{{checkout_date}}", value: this.formatCustomDate(cloned_data.date.check_out,'DD') },
				  { name: "Checkout Month (MM)", parameter: "{{checkout_month}}", value: this.formatCustomDate(cloned_data.date.check_out,'MM') },
				  { name: "Checkout Year (YYYY)", parameter: "{{checkout_year}}", value: this.formatCustomDate(cloned_data.date.check_out,'YYYY') },
				  { name: "Total Night Stay", parameter: "{{total_night}}", value: moment.duration(moment(cloned_data.date.check_out).diff(moment(cloned_data.date.check_in))).days() },
				  { name: "Total Adult", parameter: "{{total_adult}}", value: cloned_data.guest.adult },
				  { name: "Total Child", parameter: "{{total_child}}", value: cloned_data.guest.child },
				  { name: "Total Infant", parameter: "{{total_infant}}", value: cloned_data.guest.infant },
				  { name: "Total Guest", parameter: "{{total_guest}}", value: Number(cloned_data.guest.adult)+Number(cloned_data.guest.child)+Number(cloned_data.guest.infant) },
				  { name: "Currency in ISO format", parameter: "{{currency_code}}", value: this.getCurrency.code },
				  { name: "Language Used", parameter: "{{langugae_code}}", value: this.getCurrentLanguage },
				  { name: "Promo Code", parameter: "{{promo_code}}", value: cloned_data.promo_code },
				]
  			params.forEach(item=>{
	        parsed_url = parsed_url.replaceAll(item.parameter,item.value)
	      })
	      this.$openLink(parsed_url,'_blank')
      },
      loadMerchantFeedback(){
        let params = {
          module: "CORE",
          uri: "merchant-ticket-feedback",
          data: {
            merchant: this.getMerchant.id,
          },
          session: ''
        }
	      get(params.module,params.uri,params.data,params.session).then(response=>{
	        let res = response.data
	        if (res.success) {
	          this.summary = res.data.feedback_summary.total
	        }
	      })
	    },
      openGmaps(){
        let tag_a = document.createElement('a')
        tag_a.href = `https://maps.google.com/?q=${this.getMerchant.lat},${this.getMerchant.lng}`
        tag_a.target = '_blank'
        tag_a.click()
        tag_a.remove()
      },
      checkStatus(){
      	this.$emit('checkReservationStatus')
      }
		}
	}
</script>
<style type="text/css">
.flickity-page-dots {
  bottom: 16px!important;
}
.flickity-page-dots .dot {
  width: 8px!important;
  height: 8px!important;
  margin: 0 2.5px!important;
  background: #fff!important;
  opacity: 0.50!important;
 }
 .flickity-page-dots .dot.is-selected{
 	opacity: 1!important;
 }
</style>



// WEBPACK FOOTER //
// src/pages/hotel/HotelHomePageMobile.vue